module.exports = __webpack_public_path__ + "img/collection-engagementRingsCollectionRings.926ddb9.webp";